import React from 'react';
import { Card, CardContent } from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import { Download, BarChart3, FileText, Users, DollarSign, TrendingUp, Shield } from 'lucide-react';

const reports = [
  { name: 'Financial Summary', description: 'Deposits, withdrawals, earnings overview', icon: DollarSign },
  { name: 'User Report', description: 'Registration, activity, and growth', icon: Users },
  { name: 'Investment Report', description: 'Plan performance and investment volume', icon: TrendingUp },
  { name: 'Commission Report', description: 'Direct and level commission payouts', icon: BarChart3 },
  { name: 'KYC Report', description: 'KYC submissions and approvals', icon: Shield },
  { name: 'Audit Report', description: 'System audit trail and security events', icon: FileText },
];

export default function AdminReportsPage() {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center justify-between"><div><h1 className="text-2xl font-bold text-white">Reports</h1><p className="text-sm text-slate-400">Generate and export platform reports</p></div></div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">{reports.map((r, i) => {
        const Icon = r.icon;
        return (<Card key={i} className="p-5 hover:shadow-md transition-shadow cursor-pointer"><div className="flex items-start gap-4"><div className="w-10 h-10 bg-primary-500/10 rounded-lg flex items-center justify-center shrink-0"><Icon className="w-5 h-5 text-primary-400" /></div><div className="flex-1"><h3 className="font-semibold mb-1 text-white">{r.name}</h3><p className="text-sm text-slate-400 mb-3">{r.description}</p><Button variant="secondary" size="sm"><Download className="w-3.5 h-3.5 mr-1" />Export CSV</Button></div></div></Card>);
      })}</div>
    </div>
  );
}
